import React from "react";
import NewMarket from '../components/NewMarket';
import MarketList from '../components/MarketList';
import GMarketAltList from '../components/GMarketAltList';

class HomePage extends React.Component {
  render() {
    return this.props.isadmin ? (
      <>
        <NewMarket admin={this.props.admin} />
        <MarketList />
      </>
    ) : (
      <GMarketAltList />
    );
  }
}

export default HomePage;
